import script from "./oasis-footer.vue?vue&type=script&setup=true&lang=ts"
export * from "./oasis-footer.vue?vue&type=script&setup=true&lang=ts"

import "./oasis-footer.vue?vue&type=style&index=0&id=485649f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-485649f0"]])

export default __exports__